/** @param {any} router */
export default function (router) {
  router.group(
    {
      path: "/alfred/users/customers/messages/attachments",
    },
    /** @param {any} router */
    (router) => {
      router.group(
        {
          path: "/:userCustomerMessageAttachmentId",
        },
        /** @param {any} router */
        (router) => {
          router.push({
            id: "@api/user.customer.message.attachment@delete",
            path: "",
          });

          router.group(
            {
              path: "/action",
            },
            /** @param {any} router */
            (router) => {
              router.push({
                id: "@api/user.customer.message.attachment@download",
                path: "/download",
              });
            },
          );
        },
      );
    },
  );
}
